import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { StyledBaseDropdownButtonWrap } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/common-styles";

export const StyledDropdownButtonWrapper = styled(StyledBaseDropdownButtonWrap)`
    .DropdownButton--disabled {
        background-color: ${colorsPalettes.bluegrey[200]};
    }
`;
